import { connectableObservableDescriptor } from 'rxjs/observable/ConnectableObservable';

// usage

/* <div 
  data-module="accordion" 
  data-toggler=".{{component_class}}__column-title" 
  data-toggled=".js-toggled" 
  data-icon=".fa-chevron-down"
  data-bp="992" // optional
></div> */

export default function accordion(elem) {
  let $elem = $(elem);

  let $togglers = $elem.find($elem.data('toggler'));

  let toggledSelector = $elem.data('toggled');
  let $toggled = $elem.find(toggledSelector);
  let iconClass = $elem.data('icon');
  let mobileBeakPoint = $elem.data('bp') || 992;

  let isMobile = () => $(window).width() <= mobileBeakPoint;

  // initial
  $(window).on('load resize', () => {
    if (isMobile()) {
      $toggled.slideUp();
      $elem.find(iconClass).show();
      $togglers.css('cursor', 'pointer');
    } else {
      $toggled.slideDown();
      $elem.find(iconClass).hide();
      $togglers.css('cursor', 'default');
    }
  });

  $togglers.on('click', e => {
    if (isMobile()) {
      $(e.target)
        .nextAll()
        .filter(toggledSelector)
        .first()
        .slideToggle();

      $(e.target)
        .find(iconClass)
        .toggleClass('up');
    }
  });
}
